import { render } from "./IconDoor.vue?vue&type=template&id=eb8c208a"
import script from "./IconDoor.vue?vue&type=script&lang=js"
export * from "./IconDoor.vue?vue&type=script&lang=js"
script.render = render

export default script